module.exports = __webpack_public_path__ + "img/27f7876f77c4b7167aafb3fbbf987464.png";